export enum RoleIds {
  Owner = 1,
  Admin = 2,
  Moderator = 3,
  Member = 4
}

export enum Plans {
  Free = "free",
  Basic = "basic",
  Pro = "pro",
  Premium = "premium"
}

export enum TeamPlanLimits {
  Free = 1,
  Pro = 10,
  Premium = 100
}

export enum ModeratorPermissions {
  Events = 'read-write-events',
  Schedule = 'read-write-schedules',
  Library = 'read-write-library-contents',
  Workflows = 'read-write-workflows',
  LandingPages = 'read-write-landing-pages',
}
